import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { Urls } from '@/constants/urls';
import { useTriggerRiskReprocessingMutation } from '@/queries/risk-processing-status.queries';
import authService from '@/services/auth.service';
import { useToast } from '@cmpsr/components';
import { useState } from 'react';

const handleLogOut = () => {
  authService.logout();
  window.location.href = Urls.homepage;
};

export default function useQuestionnaireErrorController(resetStatus: () => void) {
  const [isRetrying, setIsRetrying] = useState(false);
  const triggerRiskReprocessingMutation = useTriggerRiskReprocessingMutation();
  const toast = useToast();

  const handleRetry = async () => {
    if (isRetrying) return;
    setIsRetrying(true);
    resetStatus();

    try {
      await triggerRiskReprocessingMutation.mutateAsync();
    } catch (error: any) {
      console.error(error);

      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: `Error ${error.response?.data?.statusCode ?? ''}`,
        description: error.response?.data?.message ?? error.message,
        status: 'error',
      });

      setIsRetrying(false);
    }
  };

  return { handleLogOut, handleRetry, isRetrying };
}
